var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("leo-input", {
        attrs: {
          type: "text",
          id: "password",
          label: _vm.passwordLabel,
          placeholder: _vm.placeholderMessage,
          password: "",
          error: _vm.isError,
          v2: "",
          errorIcon: "",
        },
        on: {
          blur: function ($event) {
            return _vm.$emit("onBlur")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "error",
            fn: function () {
              return [
                _vm.$v.password.$dirty && !_vm.$v.password.required
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.passwordInputErrMessage.mandatory) +
                          " "
                      ),
                    ])
                  : !_vm.$v.password.customValidator
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.passwordInputErrMessage.someSpecialChar) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.$v.password.$model,
          callback: function ($$v) {
            _vm.$set(
              _vm.$v.password,
              "$model",
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "$v.password.$model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }